<script setup lang="ts">
import {openDMP} from "@/core/helpers/dmp";
import {BookCheck, Loader2} from "@lucide/vue";
import {Button} from "@/core/components/ui/button";
import MSSanteButton from "@/mssante/components/MSSanteButton.vue";
import {MSSanteAttachment, MSSantePrefill} from "@/mssante/interfaces/SecureMessaging";

defineProps<{
    actionDisabled: boolean;
    loading: boolean;
    mssantePrefill?: MSSantePrefill;
    mssanteAttachmentsLoader?: () => Promise<MSSanteAttachment[]>;
    mssanteConsumerKey?: string;
    mssantePatientName?: string;
}>();
defineEmits<{
    (e: 'saveAndExit'): void;
}>();
</script>

<template>
  <div class="flex justify-between flex-wrap gap-4">
    <MSSanteButton
      v-if="mssantePrefill"
      :disabled="actionDisabled"
      :prefills="[mssantePrefill]"
      :attachments-loader="mssanteAttachmentsLoader"
      :consumer-key="mssanteConsumerKey"
      :patient-name="mssantePatientName"
    />
    <Button :disabled="actionDisabled" variant="outline" class="text-primary " @click="openDMP">
      <img src="@/assets/images/dmp.jpg" class="h-8 rounded-full" alt="DMP">
      Accéder au DMP
    </Button>
    <Button :disabled="actionDisabled" class="flex-1" variant="outline" @click="$emit('saveAndExit')">
      <div class="flex gap-1 text-primary">
        <Loader2 v-if="loading" class="animate-spin" />
        <BookCheck v-else />
        Enregistrer et terminer
      </div>
    </Button>
  </div>
</template>
